<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'NewsList',

    data: () => ({
      lists:[{
        "id":11,//id
        "title":"",//标题
        "image":""//图标
      }]
    }),
    mounted() {
      this.$api.fetch('/home/getArticleList', {
        "language":this.$i18n.locale,//
        "type":1,//类型 1手册 2广告 3产品 4活动
        "pageNumber":1,//当前页
        "pageSize":10//每页数量
      }).then((res) => {
        // console.log(res)
        this.lists=res.list
      }).catch((err) => {
        console.log(err)
      })
    }
  }
</script>
